import React from 'react';

export default props => {
  return (
    <div className="section">
      <h3 className="sectiontitle">Add your practice</h3>
      <br />
      <div className="sectionitem" style={{ maxWidth: '600px' }}>
        <p style={{ marginBottom: '15px' }}>
          If you are a DPC provider that would like to add your practice, go to
          the DPC Frontier{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://dashboard.dpcfrontier.com"
          >
            dashboard
          </a>{' '}
          and create a free account. Fill out the form, then submit your
          practice for verification. Your practice should appear in the mapper
          within 1-2 days.
        </p>
      </div>
    </div>
  );
};
